export default __webpack_public_path__ + "static/media/linkedin-filled.f7c90e80.svg";